import React from 'react';
import { Link } from 'react-router-dom';

import { slugify } from '../../../utils/slugify';

function GolfTripMobileLine({
  course,
  day,
  selectedCountrySearch,
  countryRankPrefix,
}) {
  const countryMapping = {
    England: 'england',
    Scotland: 'scotland',
    Ireland: 'ireland',
    'Northern Ireland': 'ni',
    Wales: 'wales',
    USA: 'usa',
  };
  const mappedPrefix = countryMapping[course.course_country] || '';
  const distanceInKm = (course.distance / 1000).toFixed(0); // Convert distance to km and format it to two decimal places
  const getGreenFeesRange = (greenFees) => {
    const propertiesToCheck = [
      'high_weekday',
      'high_weekday_twighlight',
      'high_weekend',
      'high_weekend_twighlight',
      'low_weekday',
      'low_weekday_twighlight',
      'low_weekend',
      'low_weekend_twighlight',
    ];

    const feeValues = propertiesToCheck
      .map((prop) => greenFees[prop])
      .filter(Boolean);

    if (feeValues.length === 0) return 'No Data';

    const minFee = Math.min(...feeValues);
    const maxFee = Math.max(...feeValues);

    return minFee === maxFee ? `£${maxFee}` : `£${minFee} - £${maxFee}`;
  };

  // Logic remains the same as the Mobile section in GolfTripLine
  return (
    <div className="md:hidden p-4 border-b-2 border-gray-300">
      <p>
        <strong>Day {day}:</strong>
      </p>
      <p>
        {course.course_name ? (
          <Link
            to={`/lists/golf-courses/${slugify(course.course_name)}`}
            className="text-indigo-600 hover:text-indigo-800 hover:underline"
          >
            {course.course_name}
          </Link>
        ) : (
          course.course_name
        )}
      </p>
      {course.distance !== undefined && course.distance !== null && (
        <p>{distanceInKm} km</p>
      )}
      <p>
        {course.course_county ? (
          <Link
            to={`/lists/golf-courses/county-ranking/${slugify(
              course.course_county,
            )}`}
            className="text-indigo-600 hover:text-indigo-800 hover:underline"
          >
            {course.course_county}
          </Link>
        ) : (
          course.course_county
        )}
      </p>
      <p>Country Rank: {course[`${mappedPrefix}_rank_gl`]}</p>
      <p>County Rank: {course.county_rank}</p>
      <p>
        Course Style:{' '}
        {course.course_style ? course.course_style : 'No Course Style Data'}
      </p>
      <p className="text-green-700">
        Green Fee Range: {getGreenFeesRange(course.green_fees)}
      </p>
    </div>
  );
}

export default GolfTripMobileLine;
